import graph from 'src/graph';
import queries from 'src/graph/queries';
import activityTransformers from '../../graph/activity-transformers';

const actions = {
  async fetchActivityData({ commit }, { activityId }) {
    try {
      const response = await graph.apolloClient.query({
        fetchPolicy: 'network-only',
        query: queries.getActivity,
        variables: {
          where: {
            id: JSON.parse(activityId)
          }
        }
      });

      const keyboardingActivity = response.data.keyboardingActivity;
      if (!keyboardingActivity) return null;

      const transformedActivity = activityTransformers.transformActivity({
        activityId: keyboardingActivity.id,
        type: keyboardingActivity.activityTypeVariant.variant,
        ...keyboardingActivity
      });

      commit('setActivityData', transformedActivity); // TODO server response comes in here
    } catch (err) {
      commit('application/setModal', { type: 'error' }, { root: true });
    }
  },

  async fetchActivityPreviewData({ commit }, { activityPreviewId, teacherCreationPreviewId }) {
    try {
      const response = await graph.apolloClient.query({
        fetchPolicy: 'network-only',
        query: queries.getActivityPreview,
        variables: {
          where: {
            ...(activityPreviewId && { activityPreviewId }),
            ...(teacherCreationPreviewId && { teacherCreationPreviewId })
          }
        }
      });

      const keyboardingActivity = response.data.keyboardingActivityPreview;
      if (!keyboardingActivity) return null;

      const transformedActivity = activityTransformers.transformActivity({
        activityId: keyboardingActivity.id,
        type: keyboardingActivity.activityTypeVariant.variant,
        ...keyboardingActivity
      });

      commit('setActivityData', transformedActivity); // TODO server response comes in here
    } catch (err) {
      commit('application/setModal', { type: 'error' }, { root: true });
    }
  },

  async fetchRandomDataForActivityTypeVariant({ commit }, variant) {
    if (!variant) return;

    try {
      const response = await graph.apolloClient.query({
        fetchPolicy: 'network-only',
        query: queries.getActivities,
        variables: {
          where: {
            activityTypeVariant: {
              variant
            },
            limit: 1,
            random: true
          }
        }
      });

      const keyboardingActivity = response.data.keyboardingActivities[0];

      const transformedActivity = activityTransformers.transformActivity({
        activityId: keyboardingActivity.id,
        type: keyboardingActivity.activityTypeVariant.variant,
        ...keyboardingActivity
      });

      commit('setActivityData', transformedActivity); // TODO server response comes in here
    } catch (err) {
      commit('application/setModal', { type: 'error' }, { root: true });
    }
  },

  async getNextCurriculumActivity({ commit }) {
    try {
      const response = await graph.apolloClient.query({
        fetchPolicy: 'network-only',
        query: queries.getNextItem
      });

      const { videos, activity } = response.data.nextKeyboardingItem;

      const transformedActivity = activityTransformers.transformActivity({
        activityId: activity.id,
        type: activity.activityTypeVariant.variant,
        ...activity,
        videos
      });

      commit('setActivityData', transformedActivity); // TODO server response comes in here
    } catch (err) {
      commit('application/setModal', { type: 'error' }, { root: true });
    }
  },

  restartActivity({ commit }, showIntro) {
    commit('keyboard/hideKeyboard', null, { root: true });
    commit('application/setToolbarMode', 'inActivityPanel', { root: true });
    commit('error/resetErrorLogger', null, { root: true });
    commit('activity/resetViewedIntro', null, { root: true });
    commit('activity/resetProgress', null, { root: true });
    commit('activity/setActivityRestarting', { isRestarting: true, showIntro }, { root: true });
  }
};

export default actions;
